module.exports = __webpack_public_path__ + "static/media/RPR 2b3.2dd34aac.jpg";